import React from 'react';
import {defaultPageConfig, Page} from "/src/domain/shared/Page";

import '../../i18n';

import {User, UserRole} from "/src/domain/shared/User";

import {mountComponentToContainer} from "/src/domain/shared/mountUtils";

import {ChallengeRatingData, Movement} from "/src/domain/challenges/ChallengeRatingData";
import ChallengeRatingApp from "/src/ui/challengeRating/ChallengeRatingApp";

window.mountPage = mountPage;

function mountPage(page: Page, pageData: ChallengeRatingData, currentUser?: User) {
    if (page !== Page.CHALLENGE_RATING) {
        console.error('Unknown page type');
        return;
    }

    mountComponentToContainer(page, pageData, currentUser, defaultPageConfig, ChallengeRatingApp)
}

// mountPage(Page.CHALLENGE_RATING, {
//         partners: [
//             'https://challenges.s10.run/i/logo_RusVelo.jpg',
//             'https://challenges.s10.run/i/Sis_logo.png',
//             'https://challenges.s10.run/i/Runlab_CMYK_Anthracitey+Yellow.png',
//             'https://challenges.s10.run/i/Kant_logo.png',
//         ],
//         currentSeasonId: 2,
//         seasons: [
//             {
//                 id: 0,
//                 name: 'Осень 2020'
//             },
//             {
//                 id: 1,
//                 name: 'Зима 2021'
//             },
//             {
//                 id: 2,
//                 name: 'Весна 2021'
//             },
//             {
//                 id: 3,
//                 name: 'Лето 2021'
//             }
//         ],
//         ratingParticipants: [
//             {
//                 id: '43438863',
//                 firstName: "Виктор",
//                 lastName: "Вершинин",
//                 place: 10,
//                 rating: 2519,
//                 movement: Movement.UP
//             },
//             {
//                 id: '43438864',
//                 firstName: "Виктор",
//                 lastName: "Вершинин",
//                 place: 10,
//                 rating: 2519,
//                 movement: Movement.UP
//             },
//             {
//                 id: '43438865',
//                 firstName: "Виктор",
//                 lastName: "Вершинин",
//                 place: 18,
//                 rating: 2519,
//                 movement: Movement.DOWN
//             },
//             {
//                 id: '43438866',
//                 firstName: "Виктор",
//                 lastName: "Вершинин",
//                 place: 2,
//                 rating: 2519,
//                 movement: Movement.IN_PLACE
//             },
//             {
//                 id: '43438867',
//                 firstName: "Виктор",
//                 lastName: "Вершинин",
//                 place: 1,
//                 rating: 2519,
//                 movement: Movement.UP
//             }
//         ],
//         ratingTrainers: [
//             {
//                 id: "86464671",
//                 firstName: "Наталия",
//                 lastName: "Тумковская",
//                 place: 1,
//                 averagePlaceInRating: 43,
//                 studentsInRating: 8,
//                 movement: Movement.DOWN,
//             },
//             {
//                 id: "86464672",
//                 firstName: "Наталия",
//                 lastName: "Тумковская",
//                 place: 1,
//                 averagePlaceInRating: 43,
//                 studentsInRating: 8,
//                 movement: Movement.UP,
//             },
//             {
//                 id: "86464673",
//                 firstName: "Наталия",
//                 lastName: "Тумковская",
//                 place: 1,
//                 averagePlaceInRating: 43,
//                 studentsInRating: 8,
//                 movement: Movement.DOWN,
//             },
//             {
//                 id: "43438864",
//                 firstName: "Наталия",
//                 lastName: "Тумковская",
//                 place: 1,
//                 averagePlaceInRating: 43,
//                 studentsInRating: 8,
//                 movement: Movement.DOWN,
//             },
//             {
//                 id: "86464675",
//                 firstName: "Наталия",
//                 lastName: "Тумковская",
//                 place: 1,
//                 averagePlaceInRating: 43,
//                 studentsInRating: 8,
//                 movement: Movement.DOWN,
//             },
//             {
//                 id: "86464676",
//                 firstName: "Наталия",
//                 lastName: "Тумковская",
//                 place: 1,
//                 averagePlaceInRating: 43,
//                 studentsInRating: 8,
//                 movement: Movement.DOWN,
//             }
//         ],
//         "clubs": [{
//             "averagePlaceInRating": 7,
//             "participantsInRating": 18,
//             "place": 1,
//             "movement": Movement.UP,
//             "id": "2",
//             "name": "S10_Team",
//             "logoUrl": "https:\/\/s10.run\/i\/team\/2.png"
//         }, {
//             "averagePlaceInRating": 11,
//             "participantsInRating": 9,
//             "place": 2,
//             "movement": Movement.DOWN,
//             "id": "12",
//             "name": "iwyll.run.team",
//             "logoUrl": "https:\/\/s10.run\/i\/team\/12.png"
//         }, {
//             "averagePlaceInRating": 18,
//             "participantsInRating": 3,
//             "place": 3,
//             "movement": Movement.DOWN,
//             "id": "18",
//             "name": "LUKOIL RUNNING CLUB",
//             "logoUrl": "https:\/\/s10.run\/i\/team\/18.png"
//         }]
//     },
//     {
//         id: '50698840',
//         role: UserRole.STUDENT,
//         isPremium: false,
//         trainingsRequests: []
//     }
// )
